import * as types from '../constants'
import { clear } from "redux-localstorage-simple"

const defaultPlanState = {
  plans: [],
  templates: [],
  plan: {
    risks: [],
    name: 'Untitled'
  },
  action_type: "",
  pendingMessage: "",
  createSuccess: false,
  createPending: false,
  loadSuccess: false,
  loadPending: false,
  getPlansSuccess: false,
  getPlansPending: false,
  isTemplate: false,
  updateSuccess: false,
  updatePending: false,
  deleteSuccess: false,
  deletePending: false,
  exportSuccess: false,
  exportPending: false,
  exportData: [],
  comparisons: [],
  getComparisonsPending: false,
  getComparisonsSuccess: false,
  profile: [],
  getProfilePending: false,
  getProfileSuccess: false,
  tree: [],
  getTreePending: false,
  planTags: [],
  deletingPlanIds: [],
  changeLogs: [],
  exception: [],
  planUploadStatus: {}
}

export default (state = defaultPlanState, action) => {

  var newState = {...state}

  switch (action.type){
    case types.CREATE_NEW_PLAN_REQUEST:
      newState.createSuccess = false;
      newState.createPending = true;
      newState.pendingMessage = "Just one second. We're fetching the plan content for you"
      return newState;
    case types.CREATE_NEW_PLAN_SUCCESS:
      newState.createPending = false;
      newState.createSuccess = true;
      return newState;
    case types.CREATE_NEW_PLAN_FAILURE:
      newState.createPending = false;
      newState.createSuccess = false;
      return newState;
    case types.UPDATE_PLAN_REQUEST:
      newState.updateSuccess = false;
      newState.updatePending = true;
      newState.pendingMessage = "Just one second. We're updating the plan content for you"
      return newState;
    case types.UPDATE_PLAN_SUCCESS:
      newState.plan = action.body;
      newState.updateSuccess = true;
      newState.updatePending = false;
      return newState;
    case types.UPDATE_PLAN_FAILURE:
      newState.updateSuccess = false;
      newState.updatePending = false;
      return newState;
    case types.DELETE_PLAN_REQUEST:
      newState.deleteSuccess = false;
      newState.deletePending = true;
      var deletingPlanIds = newState.deletingPlanIds || []
      deletingPlanIds.push(action.planId)
      newState.deletingPlanIds = deletingPlanIds
      return newState;
    case types.DELETE_PLAN_SUCCESS:
      newState.isTemplate = action.isTemplate;
      newState.deleteSuccess = true;
      newState.deletePending = false;
      return newState;
    case types.DELETE_PLAN_FAILURE:
      newState.deleteSuccess = false;
      newState.deletePending = false;
      var deletingPlanIds = newState.deletingPlanIds || []
      newState.deletingPlanIds = deletingPlanIds.filter(id => id !== action.planId)
      return newState;
    case types.GET_PLAN_CHANGE_LOGS.request:
      newState.action_type = action.type;
      newState.changeLogs = [];
      return newState;
    case types.GET_PLAN_CHANGE_LOGS.success:
      newState.action_type = action.type;
      newState.changeLogs = action.data;
      return newState;
    case types.GET_PLAN_CHANGE_LOGS.failure:
      newState.action_type = action.type;
      newState.exception = action.exception;
      return newState;
    case types.GET_PLANS_REQUEST:
      newState.getPlansSuccess = false;
      newState.getPlansPending = true;
      return newState;
    case types.GET_PLANS_SUCCESS:
      const plans = action.body;
      const planIds = plans.map(plan => plan.id)
      var deletingPlanIds = newState.deletingPlanIds || []
      newState.deletingPlanIds = deletingPlanIds.filter(id => planIds.includes(id)) // remove the plans that are already deleted
      newState.plans = plans.filter(plan => !newState.deletingPlanIds.includes(plan.id)); // hide the plans that are being deleted
      newState.isTemplate = action.isTemplate;
      newState.getPlansSuccess = true;
      newState.getPlansPending = false;
      return newState;
    case types.GET_PLANS_FAILURE:
      newState.isTemplate = false;
      newState.getPlansSuccess = false;
      newState.getPlansPending = false;
      return newState;
    case types.LOAD_PLAN_REQUEST:
      newState.loadSuccess = false;
      newState.loadPending = true;
      newState.pendingMessage = "Just one second. We're fetching the plan content for you"
      return newState;
    case types.LOAD_PLAN_SUCCESS:
      newState.plan = action.body;
      newState.plan.name = action.body.name;
      newState.loadPending = false;
      newState.loadSuccess = true;
      return newState;
    case types.LOAD_PLAN_FAILURE:
      newState.loadPending = false;
      newState.loadSuccess = false;
      return newState;
    case types.EXPORT_PLAN_TO_EXCEL_REQUEST:
      newState.exportSuccess = false;
      newState.exportPending = true;
      return newState;
    case types.EXPORT_PLAN_TO_EXCEL_SUCCESS:
      newState.exportData = action.body;
      newState.exportSuccess = true;
      newState.exportPending = false;
      return newState;
    case types.EXPORT_PLAN_TO_EXCEL_FAILURE:
      newState.exportSuccess = false;
      newState.exportPending = false;
      return newState;
    case types.GET_COMPARISONS_REQUEST:
      newState.getComparisonsSuccess = false;
      newState.getComparisonsPending = true;
      return newState;
    case types.GET_COMPARISONS_SUCCESS:
      newState.comparisons = action.body;
      newState.getComparisonsSuccess = true;
      newState.getComparisonsPending = false;
      return newState;
    case types.GET_COMPARISONS_FAILURE:
      newState = defaultPlanState;
      return newState;
    case types.GET_PROFILE_REQUEST:
      newState.getProfileSuccess = false;
      newState.getProfilePending = true;
      return newState;
    case types.GET_PROFILE_SUCCESS:
      newState.profile = action.body;
      newState.getProfileSuccess = true;
      newState.getProfilePending = false;
      return newState;
    case types.GET_PROFILE_FAILURE:
      newState = defaultPlanState;
      return newState;
    case types.GET_TREE_REQUEST:
      newState.getTreePending = true;
      return newState;
    case types.GET_TREE_SUCCESS:
      newState.tree = action.body;
      newState.getTreePending = false;
      return newState;
    case types.GET_TREE_FAILURE:
      newState = defaultPlanState;
      return newState;
    case types.GET_PLAN_TAGS_REQUEST:
      return newState;
    case types.GET_PLAN_TAGS_SUCCESS:
      newState.planTags = action.body;
      return newState;
    case types.GET_PLAN_TAGS_FAILURE:
      newState = defaultPlanState;
      return newState;
    case types.EXPORT_PLANS_REQUEST:
      newState.requestType = action.type;
      return newState;
    case types.EXPORT_PLANS_SUCCESS:
      newState.requestType = action.type;
      return newState;
    case types.EXPORT_PLANS_FAILURE:
      newState = defaultPlanState;
      return newState;
    case types.PLAN_UPLOAD_STATUS:
      newState.planUploadStatus = {
        status: action.status,
        details: action.details
      };
      return newState;
    case types.CLEAR_PLAN:
      newState = defaultPlanState;
      clear(); //Clears the Redux LocalStorage
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/plan.js